import React from 'react';
import { Button } from '@/components/atomics';
import styles from './ActionsMessage.module.scss';

type ActionsMessageProps = {
  title: string;
  message: string;
  onConfirm: () => void;
}

const className = 'actions-message';

const ActionsMessage: React.FC<ActionsMessageProps> = ({ message, title, onConfirm }) => {
  return (
    <div className={styles[className]}>
      <img height={110} src="/images/icon-success.png" alt="warning" width={110} />
      <h5>{title}</h5>
      <p>{message}</p>
      <Button circle={true} variant="primary" onClick={onConfirm}>
        Oke
      </Button>
    </div>
  );
}

export default ActionsMessage;
